<template>
  <div id="paymentTrajectories">
    <LineChart :chartData="chartData" :title="'Payment Trajectories'" :yAxesLabel="'Dollars'"/>
  </div>
</template>
<script>
import LineChart from '../charts/LineChart'
import { mapState } from 'vuex'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      chartData: []
    }
  },
  computed: {
    ...mapState(['mzs']),
    ...mapGetters(['calcYrOnePpaTotal', 'calcYrTwoPpaPotChgTotal', 'calcYrOnePpaVrmTotal', 'calcYrTwoPpaPotChgVrmTotal'])
  },
  components: { LineChart },
  mounted() {
    this.chartDataCalc()
  },
  watch: {
    calcYrOnePpaTotal: {
      handler(val) {
        this.chartDataCalc()
      },
      deep: true
    }
  },
  methods: {
    chartDataCalc() {
      this.chartData = {
        labels: ['Year One', 'Year Two'],
        datasets: [
          {
            label: 'Left Alone',
            borderColor: 'hsl(39, 100%, 70%)',
            fill: false,
            // data: [this.yrOnePpaTotal.toFixed(2), (this.yrOnePpaTotal + this.yrTwoPpaPotChgTotal).toFixed(2)]
            data: [this.calcYrOnePpaTotal.toFixed(2), (this.calcYrOnePpaTotal + this.calcYrTwoPpaPotChgTotal).toFixed(2)]
          },
          {
            label: 'With VRM',
            borderColor: 'hsl(163, 40%, 70%)',
            fill: false,
            // data: [this.yrOnePpaVrmTotal.toFixed(2), (this.yrOnePpaVrmTotal + this.yrTwoPpaPotChgVrmTotal).toFixed(2)]
            data: [this.calcYrOnePpaVrmTotal.toFixed(2), (this.calcYrOnePpaVrmTotal + this.calcYrTwoPpaPotChgVrmTotal).toFixed(2)]
          }
        ]
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/visualizations/PaymentTrajectories.vue